export const autoEquTableColumnLabels = {
    f_equ_c_typ: "Typ",
    f_equ_veh_desc_n: "Opis opcja",
    f_equ_pri_xls_desc_n: "Opis opcji",
    f_equ_pri_xls_dealer_net_mnt: "Cena netto dealer",
    f_equ_pri_xls_retail_net_mnt: "Cena netto detal.",
} as const;

export type AutoEquTableColumnKey = keyof typeof autoEquTableColumnLabels;

